import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js/instance/for-each";
import React from "react";

/**
 * @param {*[]} values List of values that should not change
 * @param {string} message Error message included in thrown error
 */
const useErrorOnChange = (values, message) => {
  const length = React.useRef(values.length);
  if (length.current !== values.length) {
    throw new Error(message);
  }
  _forEachInstanceProperty(values).call(values, value => {
    const ref = React.useRef(value);
    if (ref.current !== value) {
      throw new Error(message);
    }
  });
};
export default useErrorOnChange;